import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Stats from "@/components/Stats";
import BeforeAfter from "@/components/BeforeAfter";
import ServiceArea from "@/components/ServiceArea";
import QuoteForm from "@/components/QuoteForm";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <main className="bg-[#050505] text-white min-h-screen" data-testid="home-page">
      <Navbar />
      <Hero />
      <Marquee />
      <Services />
      <Stats />
      <BeforeAfter />
      <ServiceArea />
      <QuoteForm />
      <Contact />
      <Footer />
    </main>
  );
}
